import React from 'react'

function Header() {
  return (
    <div className='header'>
      <h1>To-do-list</h1>
    </div>
  )
}

export default Header
